import { wrappedFetch } from "./urlFunctions";
import API from "./urlConstants";


export const queryStatus = (data) => {
    return wrappedFetch(API.QUERY_STATUS, "PUT", data);
};